import apibase from './BaseAPI';

const summary = async agentId => {
    const url = `/dashboard/agent/propertysummary/${agentId}`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
}

const outdatedProperties = async agentId => {
    const url = `/property/agent/outdatedproperties/${agentId}`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
}

const bestDealProperties = async agentId => {
    const url = `/property/agent/bestDealProperties/${agentId}`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
}

const trialSummary = async agentId => {
    const url = `/dashboard/agent/trialsummary/${agentId}`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
}

export default {
    summary: summary,
    outdatedProperties: outdatedProperties,
    bestDealProperties,
    trialSummary,
}